import useBodyScrollLock from 'hooks/globals/useBodyScrollLock';
import useRequestContext from 'hooks/user/useRequestContext';
import GenericOverlay from './components/GenericOverlay';
import RootContainer from './components/RootContainer';
import { closeAllDrawers, useDrawerStore, useHasActiveDrawerInstances } from './hooks/useDrawer';

export default function DrawerRenderer() {
    const hasActiveDrawers = useHasActiveDrawerInstances();
    const { posRequest } = useRequestContext();
    const hideHeaderNavigation = posRequest?.posAction === 'Checkout' || posRequest?.posAction === 'Subscription';

    const drawInstances = useDrawerStore((state) => state.drawerInstances);
    const disableOverlay = drawInstances[drawInstances.length - 1]?.props?.disableOverlay;

    useBodyScrollLock(!disableOverlay && hasActiveDrawers);

    if (hideHeaderNavigation) {
        return null;
    }

    return (
        <>
            <RootContainer />
            <GenericOverlay isActive={!disableOverlay && hasActiveDrawers} onClick={closeAllDrawers} />
        </>
    );
}
